export default function AuditHero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/295b2b152ecda659d3e2b67fca860d3d.jpg"
          alt="Аудит сайта"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#1A2B4C]/85 via-[#1A2B4C]/75 to-[#1A2B4C]/85"></div>
      </div>

      {/* Decorative rings — hidden on mobile */}
      <div className="hidden md:block absolute top-20 right-20 w-64 h-64 border border-[#C5A880]/20 rounded-full"></div>
      <div className="hidden md:block absolute top-32 right-32 w-40 h-40 border border-[#C5A880]/30 rounded-full"></div>
      <div className="hidden md:block absolute bottom-24 left-16 w-48 h-48 border border-[#C5A880]/15 rounded-full"></div>
      <div className="hidden md:block absolute -bottom-10 left-32 w-72 h-72 border border-[#C5A880]/10 rounded-full"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 py-16 md:py-20">
        <div className="flex flex-col md:flex-row items-center gap-10 md:gap-12">

          {/* Left — text — order-1 on all screens */}
          <div className="w-full md:w-1/2 order-1 flex flex-col items-center md:items-start">
            <div className="inline-flex items-center gap-2 bg-[#C5A880]/20 border border-[#C5A880]/40 rounded-full px-4 py-2 mb-6">
              <i className="ri-shield-check-line text-[#C5A880] text-sm"></i>
              <span className="text-[#C5A880] text-xs sm:text-sm font-semibold font-['Montserrat'] uppercase tracking-widest">
                Профессиональный маркетинговый аудит
              </span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-4xl lg:text-5xl font-['Playfair_Display'] font-bold text-white mb-6 leading-tight text-center md:text-left">
              Экспертный аудит вашей посадочной страницы веб-сайта по{' '}
              <span className="text-[#C5A880]">208 пунктам</span>
            </h1>

            <p className="text-base sm:text-lg text-white/80 mb-8 max-w-xl leading-relaxed font-['Montserrat'] text-center md:text-justify">
              Узнайте, почему реклама работает, а заявок нет — получите пошаговую «карту исправлений» для роста конверсии.
            </p>

            <a
              href="#final-cta"
              className="group w-full sm:w-auto bg-[#C5A880] hover:bg-[#B39770] text-[#1A2B4C] px-8 py-4 rounded-full text-base font-bold transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer font-['Montserrat'] text-center mb-8 flex items-center justify-center sm:inline-flex"
            >
              Заказать профессиональный аудит
              <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform inline-block"></i>
            </a>

            <div className="flex flex-wrap gap-4 sm:gap-6 justify-center md:justify-start">
              {[
                { icon: 'ri-time-line', text: '2–3 рабочих дня' },
                { icon: 'ri-money-cny-circle-line', text: '3 000 ₽' },
                { icon: 'ri-file-list-3-line', text: 'PDF-отчёт' },
              ].map((item) => (
                <div key={item.text} className="flex items-center gap-2 text-white/70 font-['Montserrat'] text-sm">
                  <i className={`${item.icon} text-[#C5A880] text-lg`}></i>
                  <span>{item.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right — report visual — order-2 on all screens */}
          <div className="w-full md:w-1/2 order-2 flex justify-center items-center">
            <div className="relative w-full max-w-sm mx-auto">
              {/* Main folder card */}
              <div className="bg-white/10 backdrop-blur-md border-2 border-[#C5A880]/40 rounded-3xl p-6 sm:p-8 text-center">
                <div className="flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 bg-[#C5A880] rounded-2xl mx-auto mb-4 sm:mb-5">
                  <i className="ri-folder-open-line text-3xl sm:text-4xl text-white"></i>
                </div>
                <div className="text-[#C5A880] text-5xl sm:text-6xl font-bold font-['Playfair_Display'] mb-1">208</div>
                <div className="text-white/90 text-sm sm:text-base font-semibold font-['Montserrat'] mb-4">пунктов аудита</div>
                <div className="space-y-2">
                  {['Оффер и первый экран', 'Техническое здоровье', 'Юзабилити (UX)', 'Маркетинговая логика'].map((item, i) => (
                    <div key={i} className="flex items-center gap-2 bg-white/10 rounded-xl px-3 py-2">
                      <div className="w-5 h-5 flex items-center justify-center bg-[#C5A880] rounded-full flex-shrink-0">
                        <i className="ri-check-line text-white text-xs"></i>
                      </div>
                      <span className="text-white/80 text-xs font-['Montserrat'] text-left">{item}</span>
                    </div>
                  ))}
                </div>
                <div className="mt-4 sm:mt-5 pt-4 border-t border-[#C5A880]/30">
                  <div className="flex items-center justify-center gap-2">
                    <i className="ri-file-pdf-line text-[#C5A880] text-xl"></i>
                    <span className="text-[#C5A880] text-sm font-semibold font-['Montserrat']">Отчёт по 208 пунктам</span>
                  </div>
                </div>
              </div>
              {/* Floating badge */}
              <div className="absolute -top-4 -right-4 bg-[#C5A880] text-[#1A2B4C] text-xs font-bold font-['Montserrat'] px-3 py-1 rounded-full whitespace-nowrap">
                Полный PDF-отчёт
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 md:bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-[#C5A880] text-3xl"></i>
      </div>
    </section>
  );
}
